import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleDashboardPage" */
	'pages/vehicle/Vehicle/VehicleDashboardPage'));

export default [{ component, exact: true, path: '/vehicles/:vehicleId' }];